import React from 'react';
import { Snackbar, Alert, Box, Typography } from '@mui/material';
import QuizLayout from '../../../../shared/reusables/QuizLayout';
import QuizCard from '../../../../shared/reusables/QuizCard';
import QuizEndScreen from '../../../../shared/reusables/QuizEndScreen';
import { useQuiz } from '../../../../shared/hooks/useQuiz';

/**
 * GenericQuizMode — covers all word-category quiz modes (adjectives, adverbs, pronouns, prepositions).
 *
 * Props:
 *   endpoint   {string}  API endpoint, e.g. "adjectives"
 *   label      {string}  Display label shown in the progress bar
 *   answerKey  {string}  Key on each word object holding the correct answer (default: "darija")
 *   onBack     {fn}
 */
export default function GenericQuizMode({ endpoint, label, answerKey = 'darija', onBack }) {
    const {
        order,
        currentIndex,
        input,
        setInput,
        showAnswer,
        messages,
        quizFinished,
        loading,
        error,
        currentWord,
        handleSubmit,
        handleShowAnswer,
        nextWord,
        resetQuiz,
        handleCloseMessage,
        correctCount,
        wrongItems,
    } = useQuiz(endpoint, answerKey);

    if (loading) return null;

    if (error) {
        return (
            <Box sx={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Typography sx={{ color: '#f87171', fontFamily: "'DM Sans', sans-serif" }}>
                    ⚠️ {error}
                </Typography>
            </Box>
        );
    }

    if (order.length === 0) return null;

    if (quizFinished) {
        return (
            <QuizEndScreen
                correct={correctCount}
                total={order.length}
                wrongItems={wrongItems}
                onRetry={resetQuiz}
            />
        );
    }

    if (!currentWord) return null;

    return (
        <>
            <QuizLayout
                current={currentIndex + 1}
                total={order.length}
                label={label}
                onBack={onBack}
            >
                <QuizCard
                    question={`Wat betekent ${currentWord.dutch}?`}
                    accentWord={currentWord.dutch}
                    questionIndex={currentIndex}
                    input={input}
                    onInputChange={setInput}
                    onSubmit={handleSubmit}
                    onNext={nextWord}
                    onShowAnswer={handleShowAnswer}
                    showAnswer={showAnswer}
                    answer={currentWord[answerKey]}
                />
            </QuizLayout>

            {messages.map((msg) => (
                <Snackbar
                    key={msg.id}
                    open
                    autoHideDuration={1500}
                    onClose={() => handleCloseMessage(msg.id)}
                    anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
                >
                    <Alert
                        onClose={() => handleCloseMessage(msg.id)}
                        severity={msg.type}
                        sx={{ width: '100%', minWidth: 250 }}
                    >
                        {msg.text}
                    </Alert>
                </Snackbar>
            ))}
        </>
    );
}
